// @flow

type Wrapper = ((any) => HTMLElement) => Promise<boolean>;
const wrap: Wrapper = factory =>
  new Promise((resolve, reject) => {
    let resolved = false;
    const node = factory();

    function complete() {
      if (!resolved && (!this.readyState || this.readyState === 'complete')) {
        resolved = true;
        resolve(true);
      }
    }
    node.onload = complete;
    node.onreadystatechange = complete;
    node.onerror = reject;
    node.onabort = reject;
  });

const createStyleSheet = (url: string, ownerTeam?: string) => {
  // eslint-disable-next-line no-restricted-globals
  const node = document.createElement('link');
  node.rel = 'stylesheet';
  node.href = url;
  node.type = 'text/css';
  if (ownerTeam) {
    node.setAttribute('data-owner', ownerTeam);
  }
  // eslint-disable-next-line no-restricted-globals,no-unused-expressions
  document.head && document.head.appendChild(node);
  return node;
};

const createScript = (url: string, ownerTeam?: string) => {
  // eslint-disable-next-line no-restricted-globals
  const node = document.createElement('script');
  node.type = 'text/javascript';
  node.src = url;
  if (ownerTeam) {
    node.setAttribute('data-owner', ownerTeam);
  }
  // eslint-disable-next-line no-restricted-globals,no-unused-expressions
  document.head && document.head.appendChild(node);
  return node;
};

const importCss = (url: string, ownerTeam?: string) => wrap(() => createStyleSheet(url, ownerTeam));
const importScript = (url: string, ownerTeam?: string) => wrap(() => createScript(url, ownerTeam));

export { importCss, importScript };
